import { cn } from '@/shared/lib';

type CursorPosition = 'left' | 'right';

interface ICursorProps {
  onClick: () => void;
  cursorUrl: string;
  hidden: boolean;
  position: CursorPosition;
}

const Cursor = ({ onClick, cursorUrl, hidden, position }: ICursorProps) => {
  return (
    <div
      className={cn(
        'absolute top-[50%] z-20 h-[450px] w-[50px] translate-y-[-50%] md:h-[200vh] md:w-[200px]',
        {
          hidden,
          'right-0': position === 'right',
          'left-0': position === 'left',
        },
      )}
      style={{
        cursor: hidden ? 'default' : `url("${cursorUrl}") 0 0, auto`,
      }}
      onClick={onClick}
    />
  );
};

export default Cursor;
